// extracted by mini-css-extract-plugin
export default {"horizontalButton":"q4KmL","nested":"jGF_v","inner":"kZkb_","label":"FefTF"};